<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <!-- <a class="navbar-brand"><strong>{{company}}</strong><br/> -->
        <a class="navbar-brand"><strong>DeliverLogic Restaurant Portal</strong><br/>
          <!-- <span class="subtext"></span> -->
        </a>
      </div>
      <div class="navbar-right-menu">
  	    <router-link to="account-settings">
          <div class="navbar_account navbar-right">
            <div class="my_account navbar-right">
              <div class="initials">{{initials}}</div>
            </div>
            <span class="welcome">Welcome, {{fname}}</span>
          </div>
        </router-link>
        <ul class="nav navbar-nav navbar-right">
          <li class="open">
            <router-link to="support">
              <i class="ti-help-alt"></i>
              <p>Help</p>
            </router-link>
          </li>
          <li class="open">
            <router-link to="logout">
              <i class="ti-power-off"></i>
              <p>Logout</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false,
        initials: '',
        fname: '',
        company: ''
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      getUser () {
        var userInfo = JSON.parse(localStorage.userInfo)
        this.initials = userInfo.fname.charAt(0) + userInfo.lname.charAt(0)
        this.fname = userInfo.fname
        this.company = userInfo.company
      }
    },
    mounted () {
      this.getUser()
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// TopNavbar.vue?65fad4af